<template>
  <div class="flex flex-col h-full items-center justify-between gap-4 px-4 pb-8">
    <div class="flex flex-col items-center">
      <div class="rounded-full bg-[#E8EBF7] w-fit p-10 flex flex-row justify-center items-center">
        <font-awesome-icon class="black-icon w-10 h-10" icon="fa-solid fa-user-xmark" />
      </div>
      <p class="text-lg font-semibold pt-6 whitespace-nowrap text-BLACK">
        Thinking of leaving the crew, sailor?
      </p>
      <p class="text-sm font-normal pt-4 text-GREY">
        We’re sad to see you go, but we understand that every pirate charts their own course.
        Deleting your account will remove all your saved progress, treasures, and data permanently
        from our servers—there’s no turning back once the ship sails! Just remember,
        there will always be a plank waiting for you if you decide to return to Pirates of Web
        someday!
      </p>
    </div>

    <div class="flex flex-col gap-2 items-center w-full">
      <pow-button tertiary class="w-full" :loading="loading">
        <p class="text-BLACK text-sm">Delete Account</p>
      </pow-button>
      <pow-button secondary class="w-full" :loading="loading">
        <p class="text-sm">Cancel</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import PowButton from '@/components/PowButton.vue'
import { ref } from 'vue'

const loading = ref(false)
</script>
